import React from 'react';

import { IPressBarFields } from '../../../types/contentful';

import { ScrollReveal } from '../ScrollReveal';
import { Asset } from '../AtomicComponents/Asset';
import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { toSentenceCase } from '~/utils/stringUtils';

export function PressBar({ pressHeader, pressLogos }: IPressBarFields) {
  const isDesktop = useMediaQuery('desktop');
  const isTablet = useMediaQuery('tablet');
  const desktopLayout = isDesktop || isTablet;
  return (
    <div
      className="flex flex-col tablet:flex-col-reverse"
      data-blockid="socialProofContainer"
      data-testid="socialProofContainer"
    >
      <ScrollReveal>
        <div
          className="block-container mb-0 mt-0 tablet:mb-4 tablet:mt-4"
          data-blockid="asFeaturedOn"
        >
          <div className="w-full max-w-screen-max px-2 tablet:px-12">
            <div
              className="box-border flex w-full flex-[1_0_100%] flex-col flex-wrap justify-center [&>*]:p-1.5"
              data-blockid="asFeaturedOnLayout"
            >
              {pressHeader && (
                <div className="mb-3 box-border">
                  <h1
                    className="m-0 text-center text-base font-semibold leading-[1.25rem] tracking-[0.0625rem]"
                    data-blockid="pressBar-headline"
                    data-testid="pressBar-headline"
                  >
                    {toSentenceCase(pressHeader)}
                  </h1>
                </div>
              )}
              <div className="box-border flex w-full flex-wrap justify-center [&>*]:p-2">
                {desktopLayout && (
                  <div className="box-column flex w-full items-center justify-evenly">
                    {pressLogos?.map((pressLogo) => (
                      <div
                        key={pressLogo.fields.description}
                        className="mx-0 my-2 box-border flex w-full flex-col items-center justify-center px-1 py-0"
                        data-blockid="pressBar-image"
                      >
                        <Asset
                          asset={pressLogo}
                          fill
                          objectFit="contain"
                          className="relative mx-2 h-[72px] max-h-[72px] min-h-[72px] w-full min-w-[155px] max-w-[155px] self-stretch overflow-hidden tablet:h-[50px] tablet:max-h-[50px] tablet:min-h-[50px]"
                          style={{ minHeight: 0 }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {!desktopLayout &&
                  pressLogos?.map((pressLogo) => (
                    <div
                      key={pressLogo.fields.description}
                      className="box-column flex w-6/12 items-center justify-evenly"
                    >
                      <div
                        key={pressLogo.fields.description}
                        className="mx-0 my-2 box-border flex flex-col justify-center px-1 py-0"
                        data-blockid="pressBar-image"
                      >
                        <Asset
                          asset={pressLogo}
                          fill
                          objectFit="contain"
                          className="relative mx-2 h-[72px] max-h-[72px] min-h-[72px] w-full min-w-[155px] max-w-[155px] overflow-hidden tablet:h-[50px] tablet:max-h-[50px] tablet:min-h-[50px]"
                          style={{ minHeight: 0 }}
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  );
}
